import React, { createContext, useState } from "react";

export const GlobalContext = createContext();
export const GlobalProvider = ({ children }) => {
  const [toggleNavbar, setToggleNavbar] = useState(false);
  const [toggleSidebar, setToggleSidebar] = useState(false);
  const [sideBarOn, setSidebar] = useState(false);

  const state = {
    toggleNavbar,
    setToggleNavbar,
    toggleSidebar,
    setToggleSidebar,
    sideBarOn,
    setSidebar,
  };

  const navbarButton = () => {
    setToggleNavbar(!toggleNavbar);
  };

  const navbarClose = () => {
    setToggleNavbar(false);
  };

  const sidebarButton = () => {
    setToggleSidebar(!toggleSidebar);
    console.log(toggleSidebar);
    if (toggleSidebar === false) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }
  };

  const sidebarClose = () => {
    setToggleSidebar(false);
    document.body.classList.remove("overflow-hidden");
  };

  const doubleClose = () => {
    setToggleNavbar(false);
    setToggleSidebar(false);
    document.body.classList.remove("overflow-hidden");
  };

  const handleFunction = {
    navbarButton,
    navbarClose,
    sidebarButton,
    sidebarClose,
    doubleClose,
  };

  return (
    <GlobalContext.Provider value={{ state, handleFunction }}>
      {children}
    </GlobalContext.Provider>
  );
};
